import CryptoJS from 'crypto-js'

// AES/ECB解密方法
export const deAesEcb = (word) => {
  let key = 'ngappfgabcdefg12'
  // let iv = '偏移量要个后台一致';
  key = CryptoJS.enc.Utf8.parse(key)
  let decrypt = CryptoJS.AES.decrypt(word, key, {
    // iv: iv,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
  return decryptedStr.toString()
}


export const encryptAES = (word) => {
  let key = 'ngappfgabcdefg12'
  key = CryptoJS.enc.Utf8.parse(key)
  let encrypt = CryptoJS.AES.encrypt(word, key, {
    // iv: iv,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
	let str = CryptoJS.enc.Base64.stringify(encrypt.ciphertext).toString()
	// console.log(str)
	return str
  // let encryptedStr = encrypt.toString(CryptoJS.enc.Utf8)
  // return encryptedStr.toString()
}